import { axiosWithToken } from "@/utils/axios";

class ServiceClass {
  CreateInvestmentOffering(payload: any) {
    return axiosWithToken().post("/investments", {
      ...payload,
    });
  }

  GetInvestmentOfferings(payload?: {
    developmentType?: string;
    pageSize?: number;
    pageNumber?: number;
  }) {
    return axiosWithToken().get("/investments", {
      params: {
        developmentType: payload?.developmentType,
        pageSize: payload?.pageSize,
        pageNumber: payload?.pageNumber,
      },
    });
  }

  GetInvestmentOfferingsFilter(payload?: any) {
    return axiosWithToken().get("/investments", {
      params: payload,
    });
  }

  GetInvestmentSubscriptions(payload?: {
    developmentType?: string;
    pageSize?: number;
    pageNumber?: number;
  }) {
    return axiosWithToken().get("/investments/subscribed", {
      params: {
        investmentType: payload?.developmentType,
        pageSize: payload?.pageSize,
        pageNumber: payload?.pageNumber,
      },
    });
  }

  GetUserInvestmentOfferings(payload?: {
    developmentType?: string;
    pageSize?: number;
    pageNumber?: number;
  }) {
    return axiosWithToken().get("/investments/user", {
      params: {
        developmentType: payload?.developmentType,
        pageSize: payload?.pageSize,
        pageNumber: payload?.pageNumber,
      },
    });
  }

  GetInvestment(investmentId: string) {
    return axiosWithToken().get(`/investments/${investmentId}`);
  }
  GetIsSubscribed(investmentId: string) {
    return axiosWithToken().get(`/investments/${investmentId}/has_subscribed`);
  }

  GetInvestmentDocuments(investmentId: string) {
    return axiosWithToken().get(`/investments/${investmentId}/documents`);
  }

  GetInvestmentUpdates(investmentId: string) {
    return axiosWithToken().get(`/investments/${investmentId}/history`);
  }

  AddSubscriber(investmentId: any, payload: { transaction_reference: any }) {
    return axiosWithToken().post(
      `/investments/${investmentId}/add_subscriber`,
      {
        ...payload,
      },
    );
  }

  SaveSubscription(payload: any) {
    return axiosWithToken().post("/investments/savesubscription", {
      ...payload,
    });
  }
}

const InvestmentService = new ServiceClass();
export default InvestmentService;
